if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = null;
      this.errorContainer = null;
      this.onSubmit = this.onSubmit.bind(this);
      this.onCartUpdate = this.onCartUpdate.bind(this);
      this.onFloatingAdd = this.onFloatingAdd.bind(this);
      this.onFloatingIncrement = this.onFloatingIncrement.bind(this);
      this.onFloatingDecrement = this.onFloatingDecrement.bind(this);
      this.onFloatingQuantityChange = this.onFloatingQuantityChange.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onAddButtonMutation = this.onAddButtonMutation.bind(this);
      this.onNotifyOpen = this.onNotifyOpen.bind(this);
      this.onNotifyClose = this.onNotifyClose.bind(this);
      this.onNotifySubmit = this.onNotifySubmit.bind(this);
      this.onNotifyKeydown = this.onNotifyKeydown.bind(this);
      this.floatingVariantBound = false;
      this.cartUpdateEvent =
        (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) ||
        "cart-update";
      this.cartErrorEvent =
        (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartError) ||
        "cart-error";
    }

    connectedCallback() {
      this.form = this.querySelector("form");
      this.errorContainer = this.querySelector("[data-error-container]");
      this.addToCartButton = this.querySelector("[data-add-to-cart]");
      this.addToCartIdle = this.querySelector("[data-add-to-cart-idle]");
      this.addToCartAdding = this.querySelector("[data-add-to-cart-adding]");
      this.addToCartAdded = this.querySelector("[data-add-to-cart-added]");
      this.quantityWrapper = this.querySelector(
        `#Quantity-Selector-${this.dataset.section}`,
      );
      this.quantityInput = this.querySelector(
        'input[name="quantity"][data-quantity-variant-id]',
      );
      this.initFloatingCheckout();
      this.initNotifyModal();
      this.addedTimer = null;
      this.cartDrawer = document.getElementById("Cart-Drawer");
      if (!this.form) return;
      this.form.addEventListener("submit", this.onSubmit);
      document.addEventListener(this.cartUpdateEvent, this.onCartUpdate); // Listen for cart updates
    }

    disconnectedCallback() {
      if (!this.form) return;
      this.form.removeEventListener("submit", this.onSubmit);
      document.removeEventListener(this.cartUpdateEvent, this.onCartUpdate);
      document.removeEventListener("variant:change", this.onVariantChange);
      this.teardownFloatingCheckout();
      this.teardownNotifyModal();
      if (this.addedTimer) {
        clearTimeout(this.addedTimer);
        this.addedTimer = null;
      }
    }

    // Handle error messages
    handleErrorMessage(message = "") {
      if (this.hasAttribute("data-hide-errors")) return;
      if (!this.errorContainer) return;
      if (!message) {
        this.errorContainer.textContent = "";
        this.errorContainer.classList.add("hidden");
        return;
      }
      this.errorContainer.textContent = message;
      this.errorContainer.classList.remove("hidden");
    }

    // Set add to cart button state
    setAddToCartState(state = "idle") {
      if (!this.addToCartButton) return;
      this.addToCartButton.dataset.state = state;
      this.addToCartButton.setAttribute("aria-busy", state === "adding" ? "true" : "false");
      const isIdle = state === "idle";
      const isAdding = state === "adding";
      const isAdded = state === "added";

      if (this.addToCartIdle) {
        this.addToCartIdle.classList.toggle("opacity-0", !isIdle);
        this.addToCartIdle.classList.toggle("-translate-y-4", !isIdle);
      }
      if (this.addToCartAdding) {
        this.addToCartAdding.classList.toggle("opacity-0", !isAdding);
        this.addToCartAdding.classList.toggle("translate-y-4", isIdle);
        this.addToCartAdding.classList.toggle("-translate-y-4", isAdded);
      }
      if (this.addToCartAdded) {
        this.addToCartAdded.classList.toggle("opacity-0", !isAdded);
        this.addToCartAdded.classList.toggle("translate-y-4", !isAdded);
      }

      this.updateFloatingAddState(state);
    }

    initFloatingCheckout() {
      this.floatingCheckout = this.querySelector("[data-floating-checkout]");
      if (!this.floatingCheckout) return;
      this.teardownFloatingCheckout();

      this.floatingAddButton = this.floatingCheckout.querySelector(
        "[data-floating-add]",
      );
      this.floatingAddIdle = this.floatingCheckout.querySelector(
        "[data-floating-add-idle]",
      );
      this.floatingAddAdding = this.floatingCheckout.querySelector(
        "[data-floating-add-adding]",
      );
      this.floatingAddAdded = this.floatingCheckout.querySelector(
        "[data-floating-add-added]",
      );
      this.floatingQtyValue = this.floatingCheckout.querySelector(
        "[data-floating-quantity]",
      );
      this.floatingDecrement = this.floatingCheckout.querySelector(
        "[data-floating-decrement]",
      );
      this.floatingIncrement = this.floatingCheckout.querySelector(
        "[data-floating-increment]",
      );
      this.floatingControls = this.floatingCheckout.querySelector(
        "[data-floating-quantity-controls]",
      );
      this.floatingNotify = this.floatingCheckout.querySelector(
        "[data-floating-notify]",
      );
      this.floatingTitle = this.floatingCheckout.querySelector(
        "[data-floating-title]",
      );
      this.floatingOption = this.floatingCheckout.querySelector(
        "[data-floating-option]",
      );
      this.floatingDivider = this.floatingCheckout.querySelector(
        "[data-floating-divider]",
      );
      this.floatingPrice = this.floatingCheckout.querySelector(
        "[data-floating-price]",
      );
      this.floatingImage = this.floatingCheckout.querySelector(
        "[data-floating-image]",
      );
      this.floatingUnitPrice = Number(
        this.floatingCheckout.dataset.unitPrice || 0,
      );

      if (this.floatingAddButton) {
        this.floatingAddButton.addEventListener("click", this.onFloatingAdd);
        if (this.addToCartButton) {
          this.floatingAddButton.disabled = this.addToCartButton.disabled;
        }
      }
      if (this.floatingDecrement) {
        this.floatingDecrement.addEventListener(
          "click",
          this.onFloatingDecrement,
        );
      }
      if (this.floatingIncrement) {
        this.floatingIncrement.addEventListener(
          "click",
          this.onFloatingIncrement,
        );
      }
      if (this.quantityInput) {
        this.quantityInput.addEventListener(
          "change",
          this.onFloatingQuantityChange,
        );
        this.quantityInput.addEventListener(
          "input",
          this.onFloatingQuantityChange,
        );
        this.updateFloatingQuantity();
      } else if (this.floatingControls) {
        this.floatingControls.classList.add("opacity-60", "cursor-not-allowed");
        this.floatingControls
          .querySelectorAll("button")
          .forEach((button) => (button.disabled = true));
        if (this.floatingQtyValue) this.floatingQtyValue.textContent = "1";
      }

      document.addEventListener("variant:change", this.onVariantChange);
      this.floatingVariantBound = true;

      this.observeAddToCartButton();
      this.observeAddButtonState();
      this.observeFooter();
      this.updateFloatingPrice();
      this.updateFloatingAvailability(this.currentVariant);
    }

    initNotifyModal() {
      this.notifyModal = document.querySelector(
        `[data-notify-modal][data-section-id="${this.dataset.section}"]`,
      );
      if (!this.notifyModal) return;
      this.notifyOpenButtons = Array.from(
        this.querySelectorAll("[data-notify-open]"),
      );
      this.notifyCloseButtons = Array.from(
        this.notifyModal.querySelectorAll("[data-notify-close]"),
      );
      this.notifyOverlay = this.notifyModal.querySelector(
        "[data-notify-overlay]",
      );
      this.notifyForm = this.notifyModal.querySelector("[data-notify-form]");
      this.notifySubmit = this.notifyModal.querySelector(
        "[data-notify-submit]",
      );
      this.notifySubmitLabel = this.notifyModal.querySelector(
        "[data-notify-submit-label]",
      );
      this.notifySubmitLoading = this.notifyModal.querySelector(
        "[data-notify-submit-loading]",
      );
      this.notifyOpenButtons.forEach((button) => {
        button.addEventListener("click", this.onNotifyOpen);
      });
      this.notifyCloseButtons.forEach((button) => {
        button.addEventListener("click", this.onNotifyClose);
      });
      if (this.notifyForm) {
        this.notifyForm.addEventListener("submit", this.onNotifySubmit);
      }
      const notifyStatus = this.notifyForm
        ? this.notifyForm.querySelector("[data-notify-status]")
        : null;
      if (notifyStatus?.dataset?.notifyStatus === "success") {
        this.openNotifyModal();
      }
    }

    teardownNotifyModal() {
      if (this.notifyOpenButtons?.length) {
        this.notifyOpenButtons.forEach((button) => {
          button.removeEventListener("click", this.onNotifyOpen);
        });
      }
      if (this.notifyCloseButtons?.length) {
        this.notifyCloseButtons.forEach((button) => {
          button.removeEventListener("click", this.onNotifyClose);
        });
      }
      if (this.notifyForm) {
        this.notifyForm.removeEventListener("submit", this.onNotifySubmit);
      }
      document.removeEventListener("keydown", this.onNotifyKeydown);
    }

    onNotifyOpen(event) {
      event.preventDefault();
      this.openNotifyModal();
    }

    onNotifyClose(event) {
      event.preventDefault();
      this.closeNotifyModal();
    }

    onNotifyKeydown(event) {
      if (event.key === "Escape") {
        this.closeNotifyModal();
      }
    }

    onNotifySubmit() {
      if (!this.notifySubmit) return;
      this.notifySubmit.disabled = true;
      if (this.notifySubmitLabel) {
        this.notifySubmitLabel.classList.add("hidden");
      }
      if (this.notifySubmitLoading) {
        this.notifySubmitLoading.classList.remove("hidden");
        this.notifySubmitLoading.classList.add("flex");
      }
    }

    openNotifyModal() {
      if (!this.notifyModal) return;
      this.notifyModal.classList.remove("hidden");
      this.notifyModal.classList.add("flex");
      if (this.notifyOverlay) {
        this.notifyOverlay.classList.add("opacity-100");
        this.notifyOverlay.classList.remove("opacity-0");
      }
      document.addEventListener("keydown", this.onNotifyKeydown);
    }

    closeNotifyModal() {
      if (!this.notifyModal) return;
      if (this.notifyOverlay) {
        this.notifyOverlay.classList.remove("opacity-100");
        this.notifyOverlay.classList.add("opacity-0");
      }
      this.notifyModal.classList.add("hidden");
      this.notifyModal.classList.remove("flex");
      document.removeEventListener("keydown", this.onNotifyKeydown);
    }

    teardownFloatingCheckout() {
      if (this.floatingAddButton) {
        this.floatingAddButton.removeEventListener("click", this.onFloatingAdd);
      }
      if (this.floatingDecrement) {
        this.floatingDecrement.removeEventListener(
          "click",
          this.onFloatingDecrement,
        );
      }
      if (this.floatingIncrement) {
        this.floatingIncrement.removeEventListener(
          "click",
          this.onFloatingIncrement,
        );
      }
      if (this.quantityInput) {
        this.quantityInput.removeEventListener(
          "change",
          this.onFloatingQuantityChange,
        );
        this.quantityInput.removeEventListener(
          "input",
          this.onFloatingQuantityChange,
        );
      }
      if (this.floatingObserver) {
        this.floatingObserver.disconnect();
        this.floatingObserver = null;
      }
      if (this.floatingVariantBound) {
        document.removeEventListener("variant:change", this.onVariantChange);
        this.floatingVariantBound = false;
      }
      if (this.addButtonObserver) {
        this.addButtonObserver.disconnect();
        this.addButtonObserver = null;
      }
      if (this.floatingHideTimer) {
        clearTimeout(this.floatingHideTimer);
        this.floatingHideTimer = null;
      }
      if (this.footerObserver) {
        this.footerObserver.disconnect();
        this.footerObserver = null;
      }
    }

    observeAddToCartButton() {
      if (!this.addToCartButton || !("IntersectionObserver" in window)) return;
      this.floatingObserver = new IntersectionObserver(
        ([entry]) => {
          this.floatingInView = entry.isIntersecting;
          this.updateFloatingVisibility();
        },
        { threshold: 0 },
      );
      this.floatingObserver.observe(this.addToCartButton);
    }

    observeAddButtonState() {
      if (!this.addToCartButton || !window.MutationObserver) return;
      this.addButtonObserver = new MutationObserver(this.onAddButtonMutation);
      this.addButtonObserver.observe(this.addToCartButton, {
        attributes: true,
        attributeFilter: ["disabled", "data-state"],
      });
      this.syncFloatingDisabled();
    }

    observeFooter() {
      if (!("IntersectionObserver" in window)) return;
      const footer = document.querySelector("footer");
      if (!footer) return;
      this.footerObserver = new IntersectionObserver(
        ([entry]) => {
          this.footerInView = entry.intersectionRatio >= 0.1;
          this.updateFloatingVisibility();
        },
        { threshold: [0, 0.1, 1] },
      );
      this.footerObserver.observe(footer);
    }

    toggleFloatingVisibility(shouldShow) {
      if (!this.floatingCheckout) return;
      if (shouldShow) {
        if (this.floatingHideTimer) {
          clearTimeout(this.floatingHideTimer);
          this.floatingHideTimer = null;
        }
        if (this.floatingCheckout.classList.contains("hidden")) {
          this.floatingCheckout.classList.remove("hidden");
          requestAnimationFrame(() => {
            this.floatingCheckout.dataset.visible = "true";
          });
        } else {
          this.floatingCheckout.dataset.visible = "true";
        }
      } else {
        this.floatingCheckout.dataset.visible = "false";
        if (this.floatingHideTimer) {
          clearTimeout(this.floatingHideTimer);
        }
        this.floatingHideTimer = setTimeout(() => {
          if (this.floatingCheckout?.dataset?.visible !== "true") {
            this.floatingCheckout.classList.add("hidden");
          }
        }, 300);
      }
      const backToTop = document.querySelector("[data-scroll-top]");
      if (backToTop) {
        if (shouldShow) {
          backToTop.dataset.forceHidden = "true";
          backToTop.classList.add("hidden");
        } else {
          delete backToTop.dataset.forceHidden;
          window.dispatchEvent(new Event("scroll"));
        }
      }
    }

    updateFloatingVisibility() {
      const addToCartAbove =
        this.addToCartButton &&
        !this.floatingInView &&
        this.addToCartButton.getBoundingClientRect().top < 0;
      const shouldShow = Boolean(addToCartAbove && !this.footerInView);
      this.toggleFloatingVisibility(shouldShow);
    }

    onFloatingAdd(event) {
      event.preventDefault();
      if (this.addToCartButton) this.addToCartButton.click();
    }

    onFloatingIncrement() {
      if (!this.quantityInput) return;
      const plusButton = this.querySelector(
        'quantity-input button[name="plus"]',
      );
      if (plusButton) {
        plusButton.click();
        return;
      }
      this.updateQuantityByStep(1);
    }

    onFloatingDecrement() {
      if (!this.quantityInput) return;
      const minusButton = this.querySelector(
        'quantity-input button[name="minus"]',
      );
      if (minusButton) {
        minusButton.click();
        return;
      }
      this.updateQuantityByStep(-1);
    }

    updateQuantityByStep(direction) {
      const input = this.quantityInput;
      if (!input) return;
      const step = Number(input.step || 1);
      const min = Number(input.min || 1);
      const max = input.max ? Number(input.max) : null;
      const current = Number(input.value || min);
      let next = current + step * direction;
      if (max !== null && next > max) next = max;
      if (next < min) next = min;
      input.value = String(next);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    onFloatingQuantityChange() {
      this.updateFloatingQuantity();
    }

    updateFloatingQuantity() {
      if (!this.quantityInput || !this.floatingQtyValue) return;
      this.floatingQtyValue.textContent = String(this.quantityInput.value || 1);
      this.updateFloatingPrice();
    }

updateFloatingPrice() {
  if (!this.floatingPrice || !this.quantityInput) return;

  const quantity = Number(this.quantityInput.value || 1);
  const unit = Number(this.floatingUnitPrice || 0);
  const total = unit * quantity;

  const price = this.formatFloatingMoney(total);

  this.floatingPrice.innerHTML = price;
}

    updateFloatingAddState(state) {
      if (!this.floatingAddButton) return;
      const isIdle = state === "idle";
      const isAdding = state === "adding";
      const isAdded = state === "added";
      this.syncFloatingDisabled();
      if (this.floatingAddIdle) {
        this.floatingAddIdle.classList.toggle("hidden", !isIdle);
      }
      if (this.floatingAddAdding) {
        this.floatingAddAdding.classList.toggle("hidden", !isAdding);
      }
      if (this.floatingAddAdded) {
        this.floatingAddAdded.classList.toggle("hidden", !isAdded);
      }
    }

    updateFloatingAvailability(variant) {
      if (!this.floatingControls || !this.floatingNotify) return;
      const isAvailable = variant
        ? variant.available !== false
        : !this.addToCartButton?.disabled;
      this.floatingControls.classList.toggle("hidden", !isAvailable);
      this.floatingNotify.classList.toggle("hidden", isAvailable);
      if (this.floatingAddButton) {
        this.floatingAddButton.classList.toggle("hidden", !isAvailable);
      }
    }

    onVariantChange(event) {
      const { sectionId, variant } = event.detail || {};
      if (String(sectionId) !== String(this.dataset.section)) return;
      if (!variant) {
        this.syncFloatingDisabled();
        return;
      }

      this.floatingUnitPrice = Number(variant.price || 0);
      if (this.floatingPrice && this.quantityInput) {
        this.updateFloatingPrice();
      }

      const variantTitle =
        variant.public_title || variant.title || variant.name || "";
      const displayTitle =
        variantTitle && variantTitle !== "Default Title" ? variantTitle : "";
      if (this.floatingOption) {
        this.floatingOption.textContent = displayTitle;
      }
      if (this.floatingDivider) {
        this.floatingDivider.classList.toggle("hidden", !displayTitle);
      }

      this.syncFloatingDisabled();

      const imageUrl =
        variant?.featured_image?.src ||
        variant?.featured_media?.preview_image?.src ||
        this.floatingCheckout?.dataset?.defaultImage ||
        "";
      if (this.floatingImage && imageUrl) {
        this.floatingImage.setAttribute("src", imageUrl);
      }
      this.updateFloatingAvailability(variant);
    }

    formatFloatingMoney(amount) {
      const currency = window.Shopify?.currency?.active || "";
      const formatted = window.webvista?.formatPriceAmount
        ? window.webvista.formatPriceAmount(amount, currency)
        : null;
      if (formatted) return formatted;
      const value = amount / 100;
      return currency ? `${value.toFixed(2)} ${currency}` : value.toFixed(2);
    }

    refreshFloatingMarkup(html) {
      if (!html) return;
      const sourceCard = html.querySelector("[data-floating-checkout]");
      const targetCard = this.querySelector("[data-floating-checkout]");
      if (!targetCard) {
        if (sourceCard) {
          this.appendChild(sourceCard.cloneNode(true));
          this.initFloatingCheckout();
        }
        return;
      }

      if (sourceCard) {
        targetCard.replaceWith(sourceCard.cloneNode(true));
        this.initFloatingCheckout();
      } else {
        targetCard.remove();
        this.teardownFloatingCheckout();
      }
    }

    refreshNotifyMarkup(html) {
      if (!html) return;
      const sourceContainer = html.querySelector(
        `[data-notify-container][data-section-id="${this.dataset.section}"]`,
      );
      const targetContainer = this.querySelector(
        `[data-notify-container][data-section-id="${this.dataset.section}"]`,
      );
      if (targetContainer) {
        if (sourceContainer) {
          targetContainer.replaceWith(sourceContainer.cloneNode(true));
        } else {
          targetContainer.classList.add("hidden");
        }
      }

      const sourceDynamic = html.querySelector(
        `[data-dynamic-checkout-container][data-section-id="${this.dataset.section}"]`,
      );
      const targetDynamic = this.querySelector(
        `[data-dynamic-checkout-container][data-section-id="${this.dataset.section}"]`,
      );
      if (targetDynamic && sourceDynamic) {
        targetDynamic.innerHTML = sourceDynamic.innerHTML;
      }

      const sourceModal = html.querySelector(
        `[data-notify-modal][data-section-id="${this.dataset.section}"]`,
      );
      const targetModal = document.querySelector(
        `[data-notify-modal][data-section-id="${this.dataset.section}"]`,
      );
      if (targetModal) {
        if (sourceModal) {
          targetModal.replaceWith(sourceModal.cloneNode(true));
        } else {
          targetModal.remove();
        }
      } else if (sourceModal) {
        document.body.appendChild(sourceModal.cloneNode(true));
      }

      this.teardownNotifyModal();
      this.initNotifyModal();
    }

    onAddButtonMutation() {
      this.syncFloatingDisabled();
    }

    syncFloatingDisabled() {
      if (!this.floatingAddButton || !this.addToCartButton) return;
      this.floatingAddButton.disabled = this.addToCartButton.disabled;
    }

    // Get sections to render after adding to cart
    getSectionsToRender() {
      const drawer = document.getElementById("Cart-Drawer");
      const drawerSectionId = drawer?.dataset?.sectionId || "cart-drawer";
      return [
        {
          id: "Cart-Icon-Bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
        {
          id: "Cart-Drawer",
          section: drawerSectionId,
          selector: "[data-cart-drawer-content]",
        },
      ];
    }

    // Render updated sections
    renderSections(sections = {}) {
      this.getSectionsToRender().forEach((section) => {
        const html = sections[section.section];
        if (!html) return;
        const container = document.getElementById(section.id);
        if (!container) return;
        if (!section.selector) {
          container.innerHTML = html;
          return;
        }
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const element = parsed.querySelector(section.selector);
        if (element) {
          if (section.id === "Cart-Drawer") {
            // 刷新购物车抽屉的内容和摘要部分
            const contentTarget = container.querySelector(
              "[data-cart-drawer-content]",
            );
            const summaryTarget = container.querySelector(
              "[data-cart-drawer-summary]",
            );
            const progressTarget = container.querySelector(
              "free-shipping-progress",
            );
            if (contentTarget) {
              contentTarget.innerHTML = element.innerHTML;
              if (window.webvista?.initLazyImageAnimation) {
                window.webvista.initLazyImageAnimation(contentTarget);
              }
            }
            const summaryElement = parsed.querySelector(
              "[data-cart-drawer-summary]",
            );
            if (summaryTarget && summaryElement) {
              summaryTarget.innerHTML = summaryElement.innerHTML;
              summaryTarget.className = summaryElement.className;
            }
            const progressSource = parsed.querySelector(
              "free-shipping-progress",
            );
            if (progressTarget && progressSource) {
              progressTarget.dataset.totalAmount =
                progressSource.dataset.totalAmount || "";
            }
            if (typeof container.refreshUpsell === "function") {
              container.refreshUpsell();
            }
            return;
          }
          container.innerHTML = element.innerHTML;
          return;
        }
        container.innerHTML = html;
      });
    }

    // Open cart drawer
    async openCartDrawer(opener) {
      const header = document.querySelector("header-component");
      const cartType = header?.dataset.cartType || "drawer";
      const cartOpenOnAdd = header?.dataset.cartOpenOnAdd !== "false";
      if (!cartOpenOnAdd) {
        if (window.location.pathname === (window.routes?.cart_url || "/cart")) {
          window.location.reload();
        }
        return;
      }
      if (cartType === "page") {
        const cartUrl = window.routes?.cart_url || "/cart";
        if (window.location.pathname === cartUrl) {
          window.location.reload();
        } else {
          window.location.href = cartUrl;
        }
        return;
      }
      if (!this.cartDrawer) {
        this.cartDrawer = document.getElementById("Cart-Drawer");
      }
      if (!this.cartDrawer) return;
      if (typeof this.cartDrawer.show === "function") {
        this.cartDrawer.show(opener);
        return;
      }
      await customElements.whenDefined("cart-drawer");
      if (typeof this.cartDrawer.show === "function") {
        this.cartDrawer.show(opener);
      }
    }

    // Handle cart update events
    // Fetch and update quantity rules if applicable
    onCartUpdate(event) {
      const variantId = event.detail?.variantId;
      if (!variantId) return;

      const input = this.quantityInput;
      if (!input) return;
      if (String(input.dataset.quantityVariantId) !== String(variantId)) return;
      this.fetchQuantityRules(variantId);
    }

    // Fetch quantity rules for the given variant
    async fetchQuantityRules(variantId) {
      if (!this.quantityWrapper || !variantId) return;

      const html = await webvista.fetchHtml(
        `${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`,
      );
      const targetWrapper = html.getElementById(
        `Quantity-Selector-${this.dataset.section}`,
      );
      this.updateQuantityRules(this.quantityWrapper, targetWrapper); // Update the quantity input attributes
      // Update quantity input boundaries if applicable
      const quantityInput =
        this.quantityWrapper.querySelector("quantity-input");
      if (
        quantityInput &&
        typeof quantityInput.setQuantityBoundaries === "function"
      ) {
        quantityInput.setQuantityBoundaries(true);
      }
    }

    // Update quantity input attributes based on fetched rules
    updateQuantityRules(target, source) {
      if (!target || !source) return;
      const targetInput = target.querySelector("input[name='quantity']");
      const updatedInput = source.querySelector("input[name='quantity']");

      if (targetInput && updatedInput) {
        const attributes = [
          "data-cart-quantity",
          "data-min",
          "data-max",
          "step",
        ];
        attributes.forEach((attribute) => {
          const valueUpdated = updatedInput.getAttribute(attribute);
          if (valueUpdated != null) {
            targetInput.setAttribute(attribute, valueUpdated);
          }
        });
      }
    }

    // Handle form submission
    async onSubmit(event) {
      event.preventDefault();
      if (!this.form) return;

      const submitButton = this.form.querySelector('[name="add"]');
      submitButton?.classList.add("loading");
      this.setAddToCartState("adding");
      this.handleErrorMessage("");

      try {
        const config = webvista.fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers[
          "Content-Type"
        ]; /* 浏览器会自动为 formData 对象生成带有边界(boundary)的 multipart/form-data 类型*/

        // 构建表单数据
        const formData = new FormData(this.form);

        // Check for gift toggle
        const giftToggle = document.querySelector(
          `[data-gift-toggle][data-section="${this.dataset.section}"]`,
        );
        if (giftToggle && giftToggle.checked) {
          const giftProductId = giftToggle.dataset.giftProductId;
          const parentId = formData.get("id");
          const quantity = formData.get("quantity") || 1;
          if (giftProductId && parentId) {
            formData.append(`items[][id]`, giftProductId);
            formData.append(`items[][quantity]`, quantity);
            formData.append(`items[][parent_id]`, parentId);
          }
        }

        const sections = this.getSectionsToRender();
        if (sections.length) {
          formData.append(
            "sections",
            sections.map((section) => section.section).join(","),
          );
        }
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        const response = await fetch("/cart/add.js", config);

        let freshSections = null;
        let isPartialAdd = false;

        if (!response.ok) {
          const errorData = await response.json();
          const message =
            errorData?.description ||
            errorData?.message ||
            "Unable to add item.";
          this.handleErrorMessage(message);
          this._partialAddMessage = message;
          document.dispatchEvent(
            new CustomEvent(this.cartErrorEvent, {
              detail: { error: errorData },
            }),
          );

          // HTTP 422 = partial add (stock limit) – Shopify added what it could.
          // Other errors (404, 500 etc.) = nothing was added, just show error.
          if (response.status === 422) {
            isPartialAdd = true;
            try {
              const sectionIds = this.getSectionsToRender().map((s) => s.section);
              const refreshConfig = webvista.fetchConfig("json", "POST");
              refreshConfig.body = JSON.stringify({
                sections: sectionIds,
                sections_url: window.location.pathname,
              });
              const refreshRes = await fetch("/cart/update.js", refreshConfig);
              if (refreshRes.ok) {
                const refreshData = await refreshRes.json();
                freshSections = refreshData?.sections;
              }
            } catch (_) {
              // silent – error message already shown
            }
          }

          if (!isPartialAdd) {
            this.setAddToCartState("idle");
            return;
          }
        } else {
          const data = await response.json();
          freshSections = data?.sections;
        }

        if (freshSections) {
          this.renderSections(freshSections);
        }
        // Re-apply error after renderSections (DOM was replaced, wiping the message)
        if (isPartialAdd && this._partialAddMessage) {
          this.errorContainer = this.querySelector("[data-error-container]");
          this.handleErrorMessage(this._partialAddMessage);
          this._partialAddMessage = null;
        }
        if (!isPartialAdd) {
          this.setAddToCartState("added");
          if (this.addedTimer) {
            clearTimeout(this.addedTimer);
          }
          this.addedTimer = setTimeout(() => {
            this.setAddToCartState("idle");
          }, 2000);
          const quickViewRoot = this.closest("[data-quick-view-root]");
          const cartDrawerOpener =
            quickViewRoot?.opener || event.submitter;
          if (quickViewRoot && typeof quickViewRoot.hide === "function") {
            quickViewRoot.hide();
          }
          if (!(this.cartDrawer && this.cartDrawer.hasAttribute("open"))) {
            await this.openCartDrawer(cartDrawerOpener);
          }
        } else {
          // Partial add (422) — show error only, don't open drawer
          this.setAddToCartState("idle");
        }
        // Reset quantity selector to min value after adding to cart
        if (this.quantityInput) {
          this.quantityInput.value = this.quantityInput.min || 1;
        }

        const variantId =
          this.quantityInput?.dataset.quantityVariantId ||
          this.form.querySelector('input[name="id"]')?.value;
        document.dispatchEvent(
          new CustomEvent(this.cartUpdateEvent, {
            detail: { variantId },
          }),
        );
      } catch (error) {
        this.handleErrorMessage("Unable to add item.");
        this.setAddToCartState("idle");
        document.dispatchEvent(
          new CustomEvent(this.cartErrorEvent, { detail: { error } }),
        );
      } finally {
        submitButton?.classList.remove("loading");
      }
    }
  }

  customElements.define("product-form", ProductForm);
}

if (!customElements.get("store-pickup")) {
  // Store Pickup Component
  class StorePickup extends HTMLElement {
    constructor() {
      super();
      this.toggleButton = null;
      this.panel = null;
      this.icon = null;
      this.list = null;
      this.empty = null;
      this.error = null;
      this.noResults = null;
      this.searchInput = null;
      this.items = [];
      this.rootUrl = "/";
      this.variantId = null;
      this.isOpen = false;
      this.onToggle = this.onToggle.bind(this);
      this.onSearch = this.onSearch.bind(this);
    }

    connectedCallback() {
      this.toggleButton = this.querySelector("[data-store-pickup-toggle]");
      this.panel = this.querySelector("[data-store-pickup-panel]");
      this.icon = this.querySelector("[data-store-pickup-icon]");
      this.list = this.querySelector("[data-store-pickup-list]");
      this.empty = this.querySelector("[data-store-pickup-empty]");
      this.error = this.querySelector("[data-store-pickup-error]");
      this.noResults = this.querySelector("[data-store-pickup-no-results]");
      this.searchInput = this.querySelector("[data-store-pickup-input]");
      this.rootUrl = this.dataset.rootUrl || "/";
      this.variantId = this.dataset.variantId || null;
      if (!this.toggleButton || !this.panel) return;

      this.toggleButton.addEventListener("click", this.onToggle);
      if (this.searchInput) {
        this.searchInput.addEventListener("input", this.onSearch);
      }
      this.setOpen(false);

      if (this.variantId && this.hasAttribute("available")) {
        this.fetchAvailability(this.variantId);
      } else {
        this.renderEmpty();
      }
    }

    disconnectedCallback() {
      if (this.toggleButton) {
        this.toggleButton.removeEventListener("click", this.onToggle);
      }
      if (this.searchInput) {
        this.searchInput.removeEventListener("input", this.onSearch);
      }
    }

    onToggle() {
      this.setOpen(!this.isOpen);
    }

    setOpen(isOpen) {
      this.isOpen = isOpen;
      this.panel.classList.toggle("grid-rows-[1fr]", isOpen);
      this.panel.classList.toggle("grid-rows-[0fr]", !isOpen);
      if (this.icon) {
        this.icon.classList.toggle("rotate-180", isOpen);
      }
      if (this.toggleButton) {
        this.toggleButton.setAttribute(
          "aria-expanded",
          isOpen ? "true" : "false",
        );
      }
    }

    updateAvailability(variant) {
      if (!variant || !variant.id || !variant.available) {
        this.removeAttribute("available");
        if (variant && variant.id) {
          this.dataset.variantId = variant.id;
        }
        this.renderEmpty();
        return;
      }

      this.variantId = variant.id;
      this.dataset.variantId = variant.id;
      this.setAttribute("available", "true");
      this.fetchAvailability(variant.id);
    }

    fetchAvailability(variantId) {
      let rootUrl = this.rootUrl || "/";
      if (!rootUrl.endsWith("/")) {
        rootUrl += "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `Network response was not ok: ${response.statusText}`,
            );
          }
          return response.text();
        })
        .then((text) => {
          const dom = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector(".shopify-section");
          this.renderPreview(dom);
        })
        .catch(() => {
          this.renderError();
        });
    }

    renderPreview(dom) {
      if (!this.list) return;
      const availability = dom
        ? dom.querySelector("[data-pickup-availability]")
        : null;
      if (!availability || availability.innerHTML.trim() === "") {
        this.renderEmpty();
        return;
      }
      this.list.innerHTML = availability.innerHTML;
      this.list.classList.remove("hidden");
      if (this.empty) this.empty.classList.add("hidden");
      if (this.error) this.error.classList.add("hidden");
      if (this.noResults) this.noResults.classList.add("hidden");
      this.setContainerVisible(true);

      this.list.querySelectorAll("[data-pickup-time]").forEach((node) => {
        if (node.textContent.trim() === "") {
          node.textContent = "Ready for pickup";
        }
      });

      this.items = Array.from(
        this.list.querySelectorAll("[data-store-search]"),
      );
      this.applyFilter("");
    }

    renderEmpty() {
      if (this.list) this.list.classList.add("hidden");
      if (this.error) this.error.classList.add("hidden");
      if (this.empty) this.empty.classList.remove("hidden");
      if (this.noResults) this.noResults.classList.add("hidden");
      this.setContainerVisible(false);
    }

    renderError() {
      if (this.list) this.list.classList.add("hidden");
      if (this.empty) this.empty.classList.add("hidden");
      if (this.error) this.error.classList.remove("hidden");
      if (this.noResults) this.noResults.classList.add("hidden");
      this.setContainerVisible(false);
    }

    setContainerVisible(visible) {
      this.classList.toggle("hidden", !visible);
    }

    onSearch(event) {
      const value = event.target.value || "";
      this.applyFilter(value);
    }

    applyFilter(value) {
      if (!this.list) return;
      const query = value.trim().toLowerCase();
      let matched = 0;

      this.items.forEach((item) => {
        const text = (item.dataset.storeSearch || "").toLowerCase();
        const isMatch = !query || text.includes(query);
        item.classList.toggle("hidden", !isMatch);
        if (isMatch) matched += 1;
      });

      if (this.noResults) {
        this.noResults.classList.toggle("hidden", matched > 0 || !query);
      }
    }
  }

  customElements.define("store-pickup", StorePickup);
}

if (!customElements.get("help-share")) {
  class HelpShare extends HTMLElement {
    constructor() {
      super();
      this.modal = null;
      this.openButtons = [];
      this.closeButtons = [];
      this.overlay = null;
      this.opener = null;
      this._focusTrap = null;
      this.shareTrigger = null;
      this.sharePanel = null;
      this.shareIcons = {};
      this.isShareOpen = false;
      this.modalCloseTimer = null;
      this.copyButtons = [];
      this.onSharePlatform = this.onSharePlatform.bind(this);
      this.onShareCopy = this.onShareCopy.bind(this);
      this.onOpen = this.onOpen.bind(this);
      this.onClose = this.onClose.bind(this);
      this.onShareToggle = this.onShareToggle.bind(this);
      this.onShareOutsideClick = this.onShareOutsideClick.bind(this);
      this.onShareKeydown = this.onShareKeydown.bind(this);
    }

    connectedCallback() {
      this.openButtons = Array.from(this.querySelectorAll("[data-help-open]"));
      const modalId = this.openButtons[0]?.getAttribute("aria-controls");
      if (modalId) {
        this.modal = document.getElementById(modalId);
      }
      this.closeButtons = this.modal
        ? Array.from(this.modal.querySelectorAll("[data-help-close]"))
        : [];
      this.overlay = this.modal
        ? this.modal.querySelector("[data-help-overlay]")
        : null;
      this.shareTrigger = this.querySelector("[data-share-trigger]");
      this.sharePanel = this.querySelector("[data-share-panel]");
      this.shareIcons = {};
      this.shareItems = Array.from(this.querySelectorAll("[data-share-item]"));
      this.shareButtons = Array.from(
        this.querySelectorAll("[data-share-platform]"),
      );
      this.copyButtons = Array.from(this.querySelectorAll("[data-share-copy]"));

      this.openButtons.forEach((button) =>
        button.addEventListener("click", this.onOpen),
      );
      this.closeButtons.forEach((button) =>
        button.addEventListener("click", this.onClose),
      );
      if (this.shareTrigger) {
        this.shareTrigger.addEventListener("click", this.onShareToggle);
      }
      this.shareButtons.forEach((button) =>
        button.addEventListener("click", this.onSharePlatform),
      );
      this.copyButtons.forEach((button) =>
        button.addEventListener("click", this.onShareCopy),
      );
    }

    disconnectedCallback() {
      this.openButtons.forEach((button) =>
        button.removeEventListener("click", this.onOpen),
      );
      this.closeButtons.forEach((button) =>
        button.removeEventListener("click", this.onClose),
      );
      if (this.shareTrigger) {
        this.shareTrigger.removeEventListener("click", this.onShareToggle);
      }
      this.shareButtons.forEach((button) =>
        button.removeEventListener("click", this.onSharePlatform),
      );
      this.copyButtons.forEach((button) =>
        button.removeEventListener("click", this.onShareCopy),
      );
      document.removeEventListener("click", this.onShareOutsideClick);
      document.removeEventListener("keydown", this.onShareKeydown);
      if (this._focusTrap && this.modal) {
        this.modal.removeEventListener("keydown", this._focusTrap);
      }
    }

    onOpen(event) {
      event.preventDefault();
      if (!this.modal) return;

      // Store opener for focus return
      this.opener = event.currentTarget;

      if (this.modalCloseTimer) {
        clearTimeout(this.modalCloseTimer);
        this.modalCloseTimer = null;
      }
      this.modal.classList.remove("hidden");
      this.modal.classList.add("flex");
      this.modal.setAttribute("aria-hidden", "false");
      this.openButtons.forEach((button) =>
        button.setAttribute("aria-expanded", "true"),
      );
      if (this.overlay) {
        requestAnimationFrame(() => {
          if (!this.overlay) return;
          this.overlay.classList.add("opacity-100");
          this.overlay.classList.remove("opacity-0");
        });
      }

      // Scroll lock
      document.documentElement.classList.add("overflow-hidden");

      // Focus trap with Escape handling
      if (!this._focusTrap) {
        this._focusTrap = webvista.createFocusTrap(this.modal, {
          onEscape: () => this.onClose(),
        });
      }
      this.modal.addEventListener("keydown", this._focusTrap);

      // Auto-focus first element
      webvista.focusFirstElement(this.modal);
    }

    onClose(event) {
      if (event) event.preventDefault();
      if (!this.modal) return;
      if (this.overlay) {
        this.overlay.classList.add("opacity-0");
        this.overlay.classList.remove("opacity-100");
      }
      this.modal.classList.add("hidden");
      this.modal.classList.remove("flex");
      this.modal.setAttribute("aria-hidden", "true");
      this.openButtons.forEach((button) =>
        button.setAttribute("aria-expanded", "false"),
      );

      // Remove focus trap
      if (this._focusTrap) {
        this.modal.removeEventListener("keydown", this._focusTrap);
      }

      // Scroll unlock
      document.documentElement.classList.remove("overflow-hidden");

      // Return focus to opener
      if (this.opener) {
        this.opener.focus();
        this.opener = null;
      }
    }

    onShareToggle(event) {
      event.preventDefault();
      if (!this.sharePanel || !this.shareTrigger) return;
      const nextOpen = !this.isShareOpen;
      this.setShareOpen(nextOpen);
      if (nextOpen && this.shareItems.length) {
        this.shareItems[0].focus();
      }
    }

    onShareOutsideClick(event) {
      if (!this.isShareOpen) return;
      const target = event.target;
      if (
        target &&
        (this.sharePanel?.contains(target) ||
          this.shareTrigger?.contains(target))
      ) {
        return;
      }
      this.setShareOpen(false);
    }

    onShareKeydown(event) {
      if (event.key === "Escape" && this.isShareOpen) {
        event.preventDefault();
        this.setShareOpen(false);
        if (this.shareTrigger) this.shareTrigger.focus();
      }
    }

    async onShareCopy(event) {
      event.preventDefault();
      const button = event.currentTarget;
      if (!button) return;
      const url = button.getAttribute("data-share-url") || window.location.href;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(url);
        } else {
          const input = document.createElement("textarea");
          input.value = url;
          input.setAttribute("readonly", "");
          input.style.position = "absolute";
          input.style.left = "-9999px";
          document.body.appendChild(input);
          input.select();
          document.execCommand("copy");
          document.body.removeChild(input);
        }
      } catch (error) {
        console.warn("Share copy failed", error);
      }
    }

    onSharePlatform(event) {
      event.preventDefault();
      const button = event.currentTarget;
      if (!button) return;
      const platform = button.getAttribute("data-share-platform");
      if (!platform) return;
      const url = this.getAttribute("data-share-url") || window.location.href;
      const title = this.getAttribute("data-share-title") || document.title;
      const image = this.getAttribute("data-share-image") || "";
      const fullImage = image.startsWith("//") ? `https:${image}` : image;
      const shareUrl = this.getShareUrl(platform, url, title, fullImage);
      if (!shareUrl) return;
      window.open(shareUrl, "_blank", "noopener,noreferrer");
    }

    getShareUrl(platform, url, title, image) {
      const encodedUrl = encodeURIComponent(url);
      const encodedTitle = encodeURIComponent(title);
      const encodedImage = encodeURIComponent(image);
      switch (platform) {
        case "facebook":
          return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        case "x":
          return `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
        case "pinterest":
          return `https://pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodedImage}&description=${encodedTitle}`;
        case "linkedin":
          return `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
        default:
          return "";
      }
    }

    setShareOpen(open) {
      if (!this.sharePanel || !this.shareTrigger) return;
      this.isShareOpen = open;
      this.sharePanel.classList.toggle("opacity-0", !open);
      this.sharePanel.classList.toggle("opacity-100", open);
      this.sharePanel.classList.toggle("pointer-events-none", !open);
      this.sharePanel.classList.toggle("pointer-events-auto", open);
      this.sharePanel.setAttribute("aria-hidden", open ? "false" : "true");
      this.shareTrigger.setAttribute("aria-expanded", open ? "true" : "false");
      this.updateShareItems(open);
      document.removeEventListener("click", this.onShareOutsideClick);
      document.removeEventListener("keydown", this.onShareKeydown);
      if (open) {
        document.addEventListener("click", this.onShareOutsideClick);
        document.addEventListener("keydown", this.onShareKeydown);
      }
    }

    updateShareItems(open) {
      if (!this.shareItems.length) return;
      const count = this.shareItems.length;
      this.shareItems.forEach((item, index) => {
        const order = open ? index : count - 1 - index;
        item.style.transitionDelay = `${order * 60}ms`;
        item.classList.toggle("opacity-0", !open);
        item.classList.toggle("opacity-100", open);
        item.setAttribute("tabindex", open ? "0" : "-1");
      });
    }
  }

  customElements.define("help-share", HelpShare);
}

if (!customElements.get("high-variant-selects")) {
  class HighVariantSelects extends HTMLElement {
    constructor() {
      super();

      // 获取初始选项值 ID 列表
      this.productForm = document.getElementById(
        `product-form-${this.dataset.section}`,
      );
      // 媒体上显示的徽章元素
      this.mediaBadges = document.querySelector(
        `[data-media-badges][data-section-id="${this.dataset.section}"]`,
      );

      this.ifAutoScrollToTop = this.hasAttribute("data-auto-scroll-to-top"); // 是否在更新媒体时自动滚动到顶部

      this.addEventListener("change", this.onVariantChange.bind(this));
    }

    // 处理变体更改事件
    onVariantChange(event) {
      this.toggleAddButtonStatus(true);
      this.removeErrorMessage();

      this.updateOptions(event.target);
      this.renderProductInfo(event.isTrusted ? event.target : null);
    }

    // 获取当前选定的变体
    updateOptions(target) {
      // 确保 select 元素的 selected 属性正确反映所选选项
      if (target.tagName === "SELECT" && target.selectedOptions.length) {
        const selectedOption = Array.from(target.options).find((option) =>
          option.getAttribute("selected"),
        );
        if (selectedOption) selectedOption.removeAttribute("selected");
        target.selectedOptions[0].setAttribute("selected", "selected");
      }

      // 更新选定的选项值 ID 列表
      this.optionValueIds = Array.from(
        this.querySelectorAll("select option:checked, fieldset input:checked"),
      )
        .map((element) => element.dataset.optionValueId)
        .filter(Boolean);
    }

    updateMedia() {
      if (!this.currentVariant?.featured_media?.id) return;

      const mediaGallery = document.getElementById(
        `Media-Gallery-${this.dataset.section}`,
      );
      if (mediaGallery) {
        mediaGallery.updateGallery(
          this.currentVariant.featured_media.id,
          this.ifAutoScrollToTop,
        );
      }

      const stackedGallery = document.getElementById(
        `Media-Stacked-${this.dataset.section}`,
      );
      if (stackedGallery) {
        const target = stackedGallery.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`,
        );
        if (target) {
          target.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
      );

      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    setUnavailable() {
      const hidden_element_ids = [
        `Price-${this.dataset.section}`,
        `Inventory-${this.dataset.section}`,
        `Sku-${this.dataset.section}`,
        `Price-Per-Item-${this.dataset.section}`,
        `Volume-Note-${this.dataset.section}`,
        `Volume-${this.dataset.section}`,
        `Quantity-Rules-${this.dataset.section}`,
      ];

      hidden_element_ids.forEach((id) => {
        const element = document.getElementById(id);
        if (element) element.classList.add("hidden");
      });
    }

    updatePickupAvailability() {
      const storePickup = document.querySelector(
        "store-pickup[data-store-pickup]",
      );
      if (!storePickup) return;

      if (typeof storePickup.updateAvailability === "function") {
        storePickup.updateAvailability(this.currentVariant);
      }
    }

    removeErrorMessage() {
      if (!this.productForm) return;

      this.productForm.closest("product-form")?.handleErrorMessage();
    }

    // 渲染产品信息
    renderProductInfo(target = null) {
      this.abortController?.abort();
      this.abortController = new AbortController();

      const url = new URL(this.dataset.url, window.location.origin);
      url.searchParams.set("option_values", this.optionValueIds.join(","));
      url.searchParams.set("section_id", this.sourceSectionId);
      webvista
        .fetchHtml(url.toString(), this.abortController.signal)
        .then((html) => {
          this.updateBlock(html, "Variant-Selects");
          this.getCurrentVariant();
          const formElement = document.querySelector(
            `product-form[data-section="${this.dataset.section}"]`,
          );
          if (formElement) {
            if (typeof formElement.refreshNotifyMarkup === "function") {
              formElement.refreshNotifyMarkup(html);
            }
            if (typeof formElement.refreshFloatingMarkup === "function") {
              formElement.refreshFloatingMarkup(html);
            }
          }

          this.syncQuantityVisibilityFromHtml(html); // 同步数量选择器的可见性
          this.syncMediaBadgesFromHtml(html); // 同步媒体徽章
          this.syncMediaGalleryFromHtml(html); // 同步媒体相册（用于变体媒体分组）

          if (!this.currentVariant) {
            this.toggleAddButtonStatus(
              true,
              window["variantStrings"]["unavailable"],
            );
            return this.setUnavailable();
          }

          this.updateVariantInput();
          this.updateURL();
          this.updateBlock(html, "Store-Pickup");
          this.updatePickupAvailability();
          this.updateMedia();

          const addCartButtonSource = html.getElementById(
            `Product-Submit-Button-${this.sourceSectionId}`,
          );
          const addCartLabelSource = addCartButtonSource
            ? addCartButtonSource.querySelector("[data-add-to-cart-idle]")
            : null;
          this.toggleAddButtonStatus(
            addCartButtonSource
              ? addCartButtonSource.hasAttribute("disabled")
              : true,
            addCartLabelSource
              ? addCartLabelSource.textContent.trim()
              : window["variantStrings"]["soldOut"],
          );

          this.updateBlock(html, "Price");
          this.updateBlock(
            html,
            "Inventory",
            true,
            null,
            ({ innerHTML }) => innerHTML === "",
          );
          this.updateBlock(
            html,
            "Sku",
            true,
            null,
            ({ innerHTML }) => innerHTML === "",
          );

          this.updateBlock(html, "Share-Link");

          // Re-init lazy loading after variant-driven DOM updates.
          const sectionRoot =
            document.querySelector(`[data-section="${this.dataset.section}"]`) ||
            document;
          requestAnimationFrame(() => {
            window.webvista?.initLazyImageAnimation?.(sectionRoot);
            window.webvista?.initTooltips?.(sectionRoot);
          });

          document.dispatchEvent(
            new CustomEvent("variant:change", {
              detail: {
                sectionId: this.dataset.section,
                html,
                variant: this.currentVariant,
              },
            }),
          );
        })
        .then(() => {
          if (target) document.querySelector(`#${target.id}`)?.focus();
        })
        .catch((error) => {
          if (error.name !== "AbortError") {
            console.log("Variant fetch error:", error);
            console.log(window["accessibilityStrings"]["unknownError"]);
          }
        });
    }

    // 更新指定的区块内容
    updateBlock(
      html,
      blockId,
      replaceEntireBlock = true,
      selectorsToReplace,
      shouldHideCallback = (sourceElement) => false,
    ) {
      const sourceElement = html.getElementById(
        `${blockId}-${this.sourceSectionId}`,
      );
      const targetElement = document.getElementById(
        `${blockId}-${this.dataset.section}`,
      );

      if (!sourceElement || !targetElement) return;

      if (this.dataset.originalSection) {
        const clonedSource = sourceElement.cloneNode(true);
        const htmlContent = clonedSource.innerHTML;
        const regex = new RegExp(this.dataset.originalSection, "g");
        clonedSource.innerHTML = htmlContent.replace(
          regex,
          this.dataset.section,
        );
        sourceElement.innerHTML = clonedSource.innerHTML;
      }

      if (replaceEntireBlock) {
        if (!selectorsToReplace?.length) {
          targetElement.innerHTML = sourceElement.innerHTML;
        } else {
          selectorsToReplace.forEach((selector) => {
            const targetSubElement = targetElement.querySelector(selector);
            const sourceSubElement = sourceElement.querySelector(selector);

            if (targetSubElement && sourceSubElement) {
              targetSubElement.replaceWith(sourceSubElement.cloneNode(true));
            }
          });
        }
      }

      targetElement.classList.toggle(
        "hidden",
        shouldHideCallback(sourceElement),
      );
    }

    // 切换添加到购物车按钮的状态
    toggleAddButtonStatus(disable = true, text) {
      if (!this.productForm) return;

      const getButton = (id) =>
        document.getElementById(`${id}-${this.dataset.section}`);
      const updateButton = (button, text) => {
        if (button) {
          button.toggleAttribute("disabled", disable);
          if (text) {
            const textElement = button.querySelector("[data-add-to-cart-idle]");
            if (textElement) {
              textElement.textContent = text;
            } else {
              button.textContent = text;
            }
          }
        }
      };

      const addCartButton = getButton("Product-Submit-Button");
      const dynamicCheckout =
        this.productForm.querySelector(".dynamic-checkout");

      updateButton(addCartButton, text);

      if (dynamicCheckout) {
        dynamicCheckout.classList.toggle("hidden", disable && !!text);
      }
    }

    // 获取当前选定的变体
    getCurrentVariant() {
      const script = this.querySelector("script[data-selected-variant]");
      if (!script) {
        this.currentVariant = null;
        return;
      }
      const json = script.textContent;
      this.currentVariant = !!json ? JSON.parse(json) : null;
    }

    // 同步媒体徽章
    syncMediaBadgesFromHtml(html) {
      if (!this.mediaBadges || !html) return;
      const sourceBadge =
        html.querySelector(
          `[data-media-badges][data-section-id="${this.sourceSectionId}"]`,
        ) || html.querySelector("[data-media-badges]");
      if (!sourceBadge) return;
      const nextBadge = sourceBadge.cloneNode(true);
      this.mediaBadges.replaceWith(nextBadge);
      this.mediaBadges = nextBadge;
    }

    // 同步媒体相册（轮播与堆叠）
    syncMediaGalleryFromHtml(html) {
      if (!html) return;

      ["Media-Gallery", "Media-Stacked"].forEach((baseId) => {
        const sourceGallery = html.getElementById(
          `${baseId}-${this.sourceSectionId}`,
        );
        const targetGallery = document.getElementById(
          `${baseId}-${this.dataset.section}`,
        );
        if (!sourceGallery || !targetGallery) return;

        const nextGallery = sourceGallery.cloneNode(true);
        if (this.dataset.originalSection) {
          nextGallery.innerHTML = nextGallery.innerHTML
            .split(this.sourceSectionId)
            .join(this.dataset.section);
        }
        nextGallery.id = `${baseId}-${this.dataset.section}`;

        targetGallery.replaceWith(nextGallery);

        if (window.webvista?.initLazyImageAnimation) {
          window.webvista.initLazyImageAnimation(nextGallery);
        }
      });
    }

    // 同步数量选择器的可见性
    // sold out 和 unavailable 状态下隐藏数量选择器
    syncQuantityVisibilityFromHtml(html) {
      if (!html) return;
      const sourceWrapper = html.getElementById(
        `Quantity-Selector-${this.sourceSectionId}`,
      );
      const targetWrapper = document.getElementById(
        `Quantity-Selector-${this.dataset.section}`,
      );
      if (!targetWrapper) return;
      if (!sourceWrapper) {
        targetWrapper.classList.add("hidden");
        return;
      }
      targetWrapper.classList.toggle(
        "hidden",
        sourceWrapper.classList.contains("hidden"),
      );
    }

    // 获取源区块 ID
    get sourceSectionId() {
      return this.dataset.originalSection || this.dataset.section;
    }
  }

  customElements.define("high-variant-selects", HighVariantSelects);
}

// Size Guide Component
if (!customElements.get("size-guide")) {
  class SizeGuide extends HTMLElement {
    constructor() {
      super();
      this.modal = null;
      this.openButtons = [];
      this.closeButtons = [];
      this.overlay = null;
      this.opener = null;
      this._focusTrap = null;
      this.onOpen = this.onOpen.bind(this);
      this.onClose = this.onClose.bind(this);
      this._onVariantChange = this._onVariantChange.bind(this);
    }

    connectedCallback() {
      this.modal = this;
      this.modalId = this.id;
      this.closeButtons = Array.from(
        this.querySelectorAll("[data-size-guide-close]"),
      );
      this.overlay = this.querySelector("[data-size-guide-overlay]");

      this._bindOpenButtons();

      this.closeButtons.forEach((button) =>
        button.addEventListener("click", this.onClose),
      );

      // Re-bind open buttons after variant switch replaces DOM
      document.addEventListener("variant:change", this._onVariantChange);
    }

    disconnectedCallback() {
      this._unbindOpenButtons();
      this.closeButtons.forEach((button) =>
        button.removeEventListener("click", this.onClose),
      );
      document.removeEventListener("variant:change", this._onVariantChange);
      if (this._focusTrap) {
        this.modal.removeEventListener("keydown", this._focusTrap);
      }
    }

    _bindOpenButtons() {
      this.openButtons = this.modalId
        ? Array.from(
            document.querySelectorAll(
              `[data-size-guide-open][aria-controls="${this.modalId}"]`,
            ),
          )
        : [];
      this.openButtons.forEach((button) =>
        button.addEventListener("click", this.onOpen),
      );
    }

    _unbindOpenButtons() {
      this.openButtons.forEach((button) =>
        button.removeEventListener("click", this.onOpen),
      );
      this.openButtons = [];
    }

    _onVariantChange() {
      this._unbindOpenButtons();
      // Wait one frame for the DOM replacement to complete
      requestAnimationFrame(() => this._bindOpenButtons());
    }

    onOpen(event) {
      event.preventDefault();
      if (!this.modal) return;

      // Store opener for focus return
      this.opener = event.currentTarget;

      this.modal.classList.remove("hidden");
      this.modal.classList.add("flex");
      this.modal.setAttribute("aria-hidden", "false");
      this.openButtons.forEach((button) =>
        button.setAttribute("aria-expanded", "true"),
      );
      if (this.overlay) {
        requestAnimationFrame(() => {
          if (!this.overlay) return;
          this.overlay.classList.add("opacity-100");
          this.overlay.classList.remove("opacity-0");
        });
      }

      // Scroll lock
      document.documentElement.classList.add("overflow-hidden");

      // Focus trap with Escape handling
      if (!this._focusTrap) {
        this._focusTrap = webvista.createFocusTrap(this.modal, {
          onEscape: () => this.onClose(),
        });
      }
      this.modal.addEventListener("keydown", this._focusTrap);

      // Auto-focus first element
      webvista.focusFirstElement(this.modal);
    }

    onClose(event) {
      if (event) event.preventDefault();
      if (!this.modal) return;
      if (this.overlay) {
        this.overlay.classList.add("opacity-0");
        this.overlay.classList.remove("opacity-100");
      }
      this.modal.classList.add("hidden");
      this.modal.classList.remove("flex");
      this.modal.setAttribute("aria-hidden", "true");
      this.openButtons.forEach((button) =>
        button.setAttribute("aria-expanded", "false"),
      );

      // Remove focus trap
      if (this._focusTrap) {
        this.modal.removeEventListener("keydown", this._focusTrap);
      }

      // Scroll unlock
      document.documentElement.classList.remove("overflow-hidden");

      // Return focus to opener
      if (this.opener) {
        this.opener.focus();
        this.opener = null;
      }
    }
  }

  customElements.define("size-guide", SizeGuide);
}

if (!customElements.get("complementary-products")) {
  class ComplementaryProducts extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.slider = null;
      this.fetchAbort = null;
    }

    connectedCallback() {
      this.cacheElements();
      this.load();
    }

    disconnectedCallback() {
      if (this.fetchAbort) {
        this.fetchAbort.abort();
        this.fetchAbort = null;
      }
    }

    cacheElements() {
      this.track = this.querySelector("[data-complementary-track]");
      this.slider = this.querySelector("slider-component");
    }

    async load() {
      this.cacheElements();
      if (!this.track) return;

      const productId = this.dataset.productId;
      if (!productId) {
        this.classList.add("hidden");
        return;
      }

      const limit = Number.parseInt(this.dataset.limit || "4", 10) || 4;
      await this.loadRecommendations(productId, limit);
    }

    async loadRecommendations(productId, limit) {
      if (this.fetchAbort) {
        this.fetchAbort.abort();
      }
      const controller = new AbortController();
      this.fetchAbort = controller;

      try {
        const rawUrl = this.dataset.url || "";
        if (!rawUrl) throw new Error("Complementary products URL missing.");
        const url = new URL(rawUrl, window.location.origin);
        const sectionId =
          this.dataset.complementarySectionId ||
          "complementary-products-recommendations";
        url.searchParams.set("product_id", productId);
        url.searchParams.set("limit", String(limit));
        url.searchParams.set("section_id", sectionId);
        url.searchParams.set("intent", "complementary");

        const fetchHtml = window.webvista?.fetchHtml;
        const parsed = fetchHtml
          ? await fetchHtml(url.toString(), controller.signal)
          : new DOMParser().parseFromString(
              await fetch(url.toString(), { signal: controller.signal }).then(
                (response) => {
                  if (!response.ok) {
                    throw new Error("Complementary products fetch failed.");
                  }
                  return response.text();
                },
              ),
              "text/html",
            );

        const items = parsed.querySelector("[data-complementary-items]");
        if (!items || items.children.length === 0) {
          this.classList.add("hidden");
          return;
        }

        this.classList.remove("hidden");
        this.track.innerHTML = items.innerHTML;

        if (window.webvista?.initLazyImageAnimation) {
          window.webvista.initLazyImageAnimation(this.track);
        }
        this.resetSlider();
      } catch (error) {
        if (error?.name === "AbortError") return;
        this.classList.add("hidden");
      }
    }

    resetSlider() {
      if (!this.slider) return;
      if (typeof this.slider.disconnectedCallback === "function") {
        this.slider.disconnectedCallback();
      }
      if (typeof this.slider.connectedCallback === "function") {
        this.slider.connectedCallback();
      }
    }
  }

  customElements.define("complementary-products", ComplementaryProducts);
}

// ── Product Media Components (moved from global.js) ─────────────

// Media Gallery Slider Component
if (!customElements.get("media-gallery-slider")) {
  class MediaGallerySlider extends SliderComponent {
    constructor() {
      super();
      this.zoomContainers = [];
      this.zoomImages = [];
      this.onZoomEnter = this.onZoomEnter.bind(this);
      this.onZoomMove = this.onZoomMove.bind(this);
      this.onZoomLeave = this.onZoomLeave.bind(this);
      this.onZoomImageClick = this.onZoomImageClick.bind(this);
      this.onThumbClick = this.onThumbClick.bind(this);
      this.onThumbScroll = this.onThumbScroll.bind(this);
      this.onZoomOpen = this.onZoomOpen.bind(this);
      this.onZoomClose = this.onZoomClose.bind(this);
      this.onZoomPrev = this.onZoomPrev.bind(this);
      this.onZoomNext = this.onZoomNext.bind(this);
      this.onZoomThumbClick = this.onZoomThumbClick.bind(this);
      this.supportsHover = false;
      this.zoomScale = 3;
      this.thumbs = [];
      this.slides = [];
      this.activeIndex = -1;
      this.thumbRaf = null;
      this.isProgrammaticScroll = false;
      this.programmaticIndex = -1;
      this.programmaticTimer = null;
      this.programmaticTarget = null;
      this.zoomModal = null;
      this.zoomTrack = null;
      this.zoomSlides = [];
      this.zoomButton = null;
      this.zoomCloseButton = null;
      this.zoomPrevButton = null;
      this.zoomNextButton = null;
      this.zoomThumbs = [];
      this.zoomThumbsRaf = null;
      this.zoomCloseTimer = null;
      this.zoomOpener = null;
      this.onZoomStageClick = this.onZoomStageClick.bind(this);
    }

    getHoverZoomEnabled() {
      return this.dataset.hoverZoom !== "false";
    }

    getLightboxZoomEnabled() {
      return this.dataset.lightboxZoom !== "false";
    }

    updateGallery(mediaId, autoScrollToTop = false) {
      if (!mediaId || !this.slides.length) return;
      const index = this.slides.findIndex(
        (slide) => String(slide.dataset.mediaId) === String(mediaId),
      );
      if (index < 0) return;
      this.setActiveIndex(index, true);
      if (autoScrollToTop) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }

    connectedCallback() {
      super.connectedCallback();
      this.slides = Array.from(
        this.querySelectorAll(".product-media-carousel__slide"),
      );
      this.thumbs = Array.from(this.querySelectorAll("[data-media-thumb]"));
      this.thumbs.forEach((thumb) =>
        thumb.addEventListener("click", this.onThumbClick),
      );
      if (this.track) {
        this.track.addEventListener("scroll", this.onThumbScroll);
      }
      this.zoomButton = this.querySelector("[data-zoom-open]");
      this.zoomModal = this.querySelector("[data-zoom-modal]");
      this.zoomTrack = this.querySelector("[data-zoom-track]");
      this.zoomSlides = Array.from(this.querySelectorAll("[data-zoom-slide]"));
      this.zoomStage = this.querySelector(
        ".product-media-carousel__zoom-stage",
      );
      this.zoomCloseButton = this.querySelector("[data-zoom-close]");
      this.zoomPrevButton = this.querySelector("[data-zoom-prev]");
      this.zoomNextButton = this.querySelector("[data-zoom-next]");
      this.zoomThumbs = Array.from(this.querySelectorAll("[data-zoom-thumb]"));
      const lightboxZoomEnabled = this.getLightboxZoomEnabled();
      if (this.zoomButton && lightboxZoomEnabled) {
        this.zoomButton.addEventListener("click", this.onZoomOpen);
      }
      if (this.zoomCloseButton) {
        this.zoomCloseButton.addEventListener("click", this.onZoomClose);
      }
      if (this.zoomPrevButton) {
        this.zoomPrevButton.addEventListener("click", this.onZoomPrev);
      }
      if (this.zoomNextButton) {
        this.zoomNextButton.addEventListener("click", this.onZoomNext);
      }
      if (this.zoomStage) {
        this.zoomStage.addEventListener("click", this.onZoomStageClick);
      }
      this.zoomThumbs.forEach((thumb) =>
        thumb.addEventListener("click", this.onZoomThumbClick),
      );
      // Initialize 3D model viewers (must be before syncActiveThumb)
      this.modelViewers = new Map();
      this.initModelViewers();

      // Force initial active state (reset to -1 to ensure setActiveIndex runs)
      this.activeIndex = -1;
      this.syncActiveThumb();

      this.supportsHover =
        window.matchMedia &&
        window.matchMedia("(hover: hover) and (pointer: fine)").matches;
      if (!this.supportsHover) return;

      const scaleAttr = this.getAttribute("data-scale");
      if (scaleAttr) {
        const parsed = Number.parseFloat(scaleAttr);
        if (!Number.isNaN(parsed) && parsed > 1) {
          this.zoomScale = parsed;
        }
      }

      if (this.getHoverZoomEnabled()) {
        this.zoomContainers = Array.from(
          this.querySelectorAll("[data-zoom-container]"),
        );
        this.zoomContainers.forEach((container) => {
          container.addEventListener("mouseenter", this.onZoomEnter);
          container.addEventListener("mousemove", this.onZoomMove);
          container.addEventListener("mouseleave", this.onZoomLeave);
        });
      }
      if (lightboxZoomEnabled) {
        this.zoomImages = Array.from(
          this.querySelectorAll(".product-media-carousel__image"),
        );
        this.zoomImages.forEach((image) => {
          image.addEventListener("click", this.onZoomImageClick);
        });
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.zoomContainers.forEach((container) => {
        container.removeEventListener("mouseenter", this.onZoomEnter);
        container.removeEventListener("mousemove", this.onZoomMove);
        container.removeEventListener("mouseleave", this.onZoomLeave);
      });
      this.zoomContainers = [];
      if (this.zoomImages) {
        this.zoomImages.forEach((image) => {
          image.removeEventListener("click", this.onZoomImageClick);
        });
      }
      this.zoomImages = [];
      this.thumbs.forEach((thumb) =>
        thumb.removeEventListener("click", this.onThumbClick),
      );
      this.thumbs = [];
      this.slides = [];
      if (this.track) {
        this.track.removeEventListener("scroll", this.onThumbScroll);
      }
      if (this.thumbRaf) {
        cancelAnimationFrame(this.thumbRaf);
        this.thumbRaf = null;
      }
      if (this.programmaticTimer) {
        clearTimeout(this.programmaticTimer);
        this.programmaticTimer = null;
      }
      this.programmaticTarget = null;
      if (this.zoomButton) {
        this.zoomButton.removeEventListener("click", this.onZoomOpen);
      }
      if (this.zoomCloseButton) {
        this.zoomCloseButton.removeEventListener("click", this.onZoomClose);
      }
      if (this.zoomPrevButton) {
        this.zoomPrevButton.removeEventListener("click", this.onZoomPrev);
      }
      if (this.zoomNextButton) {
        this.zoomNextButton.removeEventListener("click", this.onZoomNext);
      }
      if (this.zoomStage) {
        this.zoomStage.removeEventListener("click", this.onZoomStageClick);
      }
      this.zoomThumbs.forEach((thumb) =>
        thumb.removeEventListener("click", this.onZoomThumbClick),
      );
      this.zoomThumbs = [];
      this.zoomSlides = [];
      if (this.zoomThumbsRaf) {
        cancelAnimationFrame(this.zoomThumbsRaf);
        this.zoomThumbsRaf = null;
      }
      if (this.zoomCloseTimer) {
        clearTimeout(this.zoomCloseTimer);
        this.zoomCloseTimer = null;
      }
      if (this._zoomFocusTrap) {
        this.zoomModal.removeEventListener("keydown", this._zoomFocusTrap);
        this._zoomFocusTrap = null;
      }
      if (this.modelViewers) {
        this.modelViewers.forEach((ui) => {
          if (ui && typeof ui.destroy === "function") ui.destroy();
        });
        this.modelViewers.clear();
      }
    }

    initModelViewers() {
      const viewers = this.querySelectorAll("model-viewer");
      if (!viewers.length) return;

      const setup = () => {
        viewers.forEach((viewer) => {
          if (this.modelViewers.has(viewer)) return;
          this.modelViewers.set(viewer, new Shopify.ModelViewerUI(viewer));
          // Prevent drag events from bubbling to carousel
          const wrapper =
            viewer.closest(".shopify-model-viewer-ui") || viewer;
          const stop = (e) => e.stopPropagation();
          for (const evt of ["pointerdown", "pointerup", "pointermove"]) {
            wrapper.addEventListener(evt, stop);
          }
          wrapper.style.touchAction = "none";
        });
      };

      if (window.Shopify?.ModelViewerUI) {
        setup();
      } else {
        Shopify.loadFeatures([
          {
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: (errors) => {
              if (errors) return;
              setup();
            },
          },
        ]);
      }
    }

    pauseExternalVideo(slide) {
      const iframe = slide.querySelector("iframe");
      if (!iframe) return;
      const src = iframe.src || "";
      if (src.includes("youtube.com") || src.includes("youtube-nocookie.com")) {
        iframe.contentWindow?.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*",
        );
      } else if (src.includes("vimeo.com")) {
        iframe.contentWindow?.postMessage('{"method":"pause"}', "*");
      }
    }

    resumeExternalVideo(slide) {
      const iframe = slide.querySelector("iframe");
      if (!iframe) return;
      const src = iframe.src || "";
      if (src.includes("youtube.com") || src.includes("youtube-nocookie.com")) {
        iframe.contentWindow?.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          "*",
        );
      } else if (src.includes("vimeo.com")) {
        iframe.contentWindow?.postMessage('{"method":"play"}', "*");
      }
    }

    onZoomStageClick(event) {
      const target = event.target;
      if (target && target.closest("img")) {
        this.onZoomClose(event);
      }
    }

    onZoomOpen(event) {
      event.preventDefault();
      this.zoomOpener = event.currentTarget;
      const currentIndex = this.getCurrentSlideIndex();
      const startIndex =
        this.activeIndex >= 0
          ? this.activeIndex
          : currentIndex >= 0
            ? currentIndex
            : 0;
      this.openZoomAtIndex(startIndex);
    }

    onZoomImageClick(event) {
      event.preventDefault();
      this.zoomOpener = event.currentTarget;
      const image = event.currentTarget;
      const mediaNode = image.closest("[data-media-id]");
      const mediaId = mediaNode ? mediaNode.dataset.mediaId : null;
      let index = -1;
      if (mediaId) {
        index = this.zoomSlides.findIndex(
          (slide) => String(slide.dataset.mediaId) === String(mediaId),
        );
      }
      if (index < 0) {
        const slide = image.closest(".product-media-carousel__slide");
        index = slide ? this.slides.indexOf(slide) : -1;
      }
      if (this.isDragging) return;
      const targetIndex = index >= 0 ? index : this.activeIndex;
      this.setActiveIndex(targetIndex, false);
      this.openZoomAtIndex(targetIndex >= 0 ? targetIndex : 0);
    }

    openZoomAtIndex(index) {
      if (!this.zoomModal) return;
      if (this.zoomCloseTimer) {
        clearTimeout(this.zoomCloseTimer);
        this.zoomCloseTimer = null;
      }
      document.documentElement.classList.add("overflow-hidden");
      this.zoomModal.setAttribute("aria-hidden", "false");
      this.zoomModal.classList.remove("hidden");
      this.zoomModal.classList.add("flex");
      if (window.webvista?.initLazyImageAnimation) {
        window.webvista.initLazyImageAnimation(this.zoomModal);
      }
      const startIndex = index >= 0 ? index : 0;
      if (this.zoomTrack) {
        this.zoomTrack.style.scrollBehavior = "auto";
      }
      this.setZoomIndex(startIndex, true, true);
      requestAnimationFrame(() => {
        if (!this.zoomModal) return;
        this.zoomModal.classList.add("opacity-100", "scale-100");
        this.zoomModal.classList.remove("opacity-0", "scale-[0.98]");
        if (this.zoomTrack) {
          this.zoomTrack.style.scrollBehavior = "";
        }
      });
      this._zoomFocusTrap = window.webvista.createFocusTrap(this.zoomModal, {
        onEscape: (e) => this.onZoomClose(e),
      });
      this.zoomModal.addEventListener("keydown", this._zoomFocusTrap);
      if (this.zoomCloseButton) {
        this.zoomCloseButton.focus();
      }
    }

    getCurrentSlideIndex() {
      if (!this.track || !this.slides.length) return -1;
      const scrollLeft = this.track.scrollLeft;
      let nearestIndex = 0;
      let smallest = Math.abs(this.getSlideTarget(this.slides[0]) - scrollLeft);
      this.slides.forEach((slide, index) => {
        const distance = Math.abs(this.getSlideTarget(slide) - scrollLeft);
        if (distance < smallest) {
          smallest = distance;
          nearestIndex = index;
        }
      });
      return nearestIndex;
    }

    onZoomClose(event) {
      if (event) event.preventDefault();
      if (!this.zoomModal) return;
      if (this._zoomFocusTrap) {
        this.zoomModal.removeEventListener("keydown", this._zoomFocusTrap);
        this._zoomFocusTrap = null;
      }
      this.zoomModal.setAttribute("aria-hidden", "true");
      this.zoomSlides.forEach((slide) => {
        const video = slide.querySelector("video");
        if (video) video.pause();
        const modelViewer = slide.querySelector("model-viewer");
        if (modelViewer && this.modelViewers) {
          const ui = this.modelViewers.get(modelViewer);
          if (ui && typeof ui.pause === "function") ui.pause();
        }
        if (slide.dataset.mediaType === "external_video") {
          this.pauseExternalVideo(slide);
        }
      });
      this.zoomModal.classList.remove("opacity-100", "scale-100");
      this.zoomModal.classList.add("opacity-0", "scale-[0.98]");
      var opener = this.zoomOpener;
      this.zoomCloseTimer = setTimeout(() => {
        if (!this.zoomModal) return;
        this.zoomModal.classList.add("hidden");
        this.zoomModal.classList.remove("flex");
        document.documentElement.classList.remove("overflow-hidden");
        this.zoomCloseTimer = null;
        if (opener) {
          opener.focus();
        }
      }, 300);
      this.zoomOpener = null;
    }

    onZoomPrev(event) {
      event.preventDefault();
      const count = this.zoomSlides.length;
      if (!count) return;
      const nextIndex = this.activeIndex > 0 ? this.activeIndex - 1 : count - 1;
      this.setZoomIndex(nextIndex, true, false);
      this.setActiveIndex(nextIndex, true);
    }

    onZoomNext(event) {
      event.preventDefault();
      const count = this.zoomSlides.length;
      if (!count) return;
      const nextIndex = this.activeIndex < count - 1 ? this.activeIndex + 1 : 0;
      this.setZoomIndex(nextIndex, true, false);
      this.setActiveIndex(nextIndex, true);
    }

    onZoomThumbClick(event) {
      event.preventDefault();
      const button = event.currentTarget;
      const rawIndex = button.dataset.thumbIndex;
      const index = Number.parseInt(rawIndex, 10);
      if (Number.isNaN(index)) return;
      this.setZoomIndex(index, true, false);
      this.setActiveIndex(index, true);
    }

    setZoomIndex(index, shouldScroll, instant = false) {
      const activeZoomSlide = this.zoomSlides[index];
      if (activeZoomSlide) {
        this.zoomSlides.forEach((slide, slideIndex) => {
          if (slideIndex === index) return;
          const video = slide.querySelector("video");
          if (video) video.pause();
          const modelViewer = slide.querySelector("model-viewer");
          if (modelViewer && this.modelViewers) {
            const ui = this.modelViewers.get(modelViewer);
            if (ui && typeof ui.pause === "function") ui.pause();
          }
          if (slide.dataset.mediaType === "external_video") {
            this.pauseExternalVideo(slide);
          }
        });
        const activeVideo = activeZoomSlide.querySelector("video");
        if (activeVideo && activeZoomSlide.dataset.mediaType !== "image") {
          const playPromise = activeVideo.play();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(() => {});
          }
        }
        if (activeZoomSlide.dataset.mediaType === "external_video") {
          this.resumeExternalVideo(activeZoomSlide);
        }
      }
      this.zoomThumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === index;
        thumb.classList.toggle(
          "border-[color:rgb(var(--color-foreground))]",
          isActive,
        );
        thumb.classList.toggle("border-transparent", !isActive);
        thumb.classList.toggle("opacity-100", isActive);
        thumb.classList.toggle("opacity-60", !isActive);
        thumb.setAttribute("aria-current", isActive ? "true" : "false");
      });
      if (!shouldScroll || !this.zoomTrack || !this.zoomSlides[index]) return;
      const target = this.zoomSlides[index].offsetLeft;
      if (instant) {
        this.zoomTrack.scrollLeft = target;
      } else {
        this.zoomTrack.scrollTo({ left: target, behavior: "smooth" });
      }
      if (this.zoomThumbs.length) {
        const thumbEvent = new CustomEvent("thumbnail:activate", {
          detail: { index },
          bubbles: true,
        });
        this.zoomThumbs[0].dispatchEvent(thumbEvent);
      }
    }

    onThumbClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const button = event.currentTarget;
      const rawIndex = button.dataset.thumbIndex;
      const index = Number.parseInt(rawIndex, 10);
      if (Number.isNaN(index)) return;
      this.setActiveIndex(index, true);
    }

    onThumbScroll() {
      if (this.isProgrammaticScroll) {
        if (this.track && this.programmaticTarget != null) {
          const delta = Math.abs(
            this.track.scrollLeft - this.programmaticTarget,
          );
          if (delta <= 2) {
            this.isProgrammaticScroll = false;
            this.programmaticIndex = -1;
            this.programmaticTarget = null;
          } else {
            return;
          }
        } else {
          return;
        }
      }
      if (this.thumbRaf) return;
      this.thumbRaf = requestAnimationFrame(() => {
        this.thumbRaf = null;
        this.syncActiveThumb();
      });
    }

    syncActiveThumb() {
      if (!this.track || !this.slides.length) return;
      if (this.isProgrammaticScroll) return;
      const scrollLeft = this.track.scrollLeft;
      let nearestIndex = 0;
      let smallest = Math.abs(this.getSlideTarget(this.slides[0]) - scrollLeft);
      this.slides.forEach((slide, index) => {
        const distance = Math.abs(this.getSlideTarget(slide) - scrollLeft);
        if (distance < smallest) {
          smallest = distance;
          nearestIndex = index;
        }
      });
      this.setActiveIndex(nearestIndex, false);
    }

    getSlideTarget(slide) {
      if (!slide || !this.track) return 0;
      if (slide.classList.contains("snap-center")) {
        const centerOffset = (this.track.clientWidth - slide.clientWidth) / 2;
        return slide.offsetLeft - centerOffset;
      }
      return slide.offsetLeft;
    }

    setActiveIndex(index, shouldScroll) {
      if (index === this.activeIndex) return;
      this.activeIndex = index;
      const activeSlide = this.slides[index];
      if (this.zoomButton) {
        const mediaType = activeSlide ? activeSlide.dataset.mediaType : "";
        const isImage = mediaType === "image";
        this.zoomButton.classList.toggle("hidden", !isImage);
      }
      if (activeSlide) {
        // Pause all inactive media (videos, external videos, 3D models)
        this.slides.forEach((slide, i) => {
          const videoEl = slide.querySelector("video-autoplay");
          const modelViewer = slide.querySelector("model-viewer");
          if (i === index) {
            if (videoEl) videoEl.play();
            if (slide.dataset.mediaType === "external_video") {
              this.resumeExternalVideo(slide);
            }
          } else {
            if (videoEl) videoEl.pause();
            if (slide.dataset.mediaType === "external_video") {
              this.pauseExternalVideo(slide);
            }
            if (modelViewer && this.modelViewers) {
              const ui = this.modelViewers.get(modelViewer);
              if (ui && typeof ui.pause === "function") ui.pause();
            }
          }
        });

        const mediaChangeEvent = new CustomEvent("media:change", {
          detail: {
            index,
            mediaId: activeSlide.dataset.mediaId || null,
            mediaType: activeSlide.dataset.mediaType || null,
          },
          bubbles: true,
        });
        this.dispatchEvent(mediaChangeEvent);
      }
      this.thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === index;
        if (thumb.classList.contains("quick-view-product__dot")) {
          thumb.classList.toggle("opacity-100", isActive);
          thumb.classList.toggle("opacity-50", !isActive);
        } else {
          thumb.classList.toggle(
            "border-[color:rgb(var(--color-foreground))]",
            isActive,
          );
          thumb.classList.toggle("border-transparent", !isActive);
          thumb.classList.toggle("opacity-100", isActive);
          thumb.classList.toggle("opacity-60", !isActive);
        }
        thumb.setAttribute("aria-current", isActive ? "true" : "false");
      });
      const counterEl = this.querySelector("[data-slide-counter-current]");
      if (counterEl) {
        counterEl.textContent = index + 1;
      }
      if (this.thumbs.length) {
        const thumbEvent = new CustomEvent("thumbnail:activate", {
          detail: { index },
          bubbles: true,
        });
        this.thumbs[0].dispatchEvent(thumbEvent);
      }
      if (!shouldScroll || !this.track || !this.slides[index]) return;
      this.isProgrammaticScroll = true;
      this.programmaticIndex = index;
      this.programmaticTarget = this.getSlideTarget(this.slides[index]);
      if (this.programmaticTimer) {
        clearTimeout(this.programmaticTimer);
        this.programmaticTimer = null;
      }
      const target = this.programmaticTarget;
      this.track.scrollTo({ left: target, behavior: "smooth" });
    }

    onZoomEnter(event) {
      const img = this.getZoomImage(event.currentTarget);
      if (!img) return;
      img.style.transition =
        "transform 180ms ease-out, transform-origin 180ms ease-out";
      img.style.transform = `scale(${this.zoomScale})`;
      img.style.willChange = "transform";
      img.setAttribute("draggable", "false");
    }

    onZoomMove(event) {
      const container = event.currentTarget;
      const img = this.getZoomImage(container);
      if (!img) return;
      const rect = container.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
      if (!img.style.transform || img.style.transform === "none") {
        img.style.transform = `scale(${this.zoomScale})`;
      }
    }

    onZoomLeave(event) {
      const img = this.getZoomImage(event.currentTarget);
      if (!img) return;
      img.style.transformOrigin = "center center";
      img.style.transform = "";
      img.style.willChange = "";
    }

    getZoomImage(container) {
      if (!container) return null;
      return container.querySelector("img");
    }
  }
  customElements.define("media-gallery-slider", MediaGallerySlider);
}

// Shopify XR — AR Quick Look for 3D models
window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },
  setupShopifyXR(errors) {
    if (errors) return;
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", () =>
        this.setupShopifyXR(),
      );
      return;
    }
    document.querySelectorAll('[id^="ProductJSON-"]').forEach((el) => {
      window.ShopifyXR.addModels(JSON.parse(el.textContent));
      el.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};
window.addEventListener("DOMContentLoaded", () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});

// Thumbnail Slider Component
if (!customElements.get("thumbnail-slider")) {
  class ThumbnailSlider extends SliderComponent {
    constructor() {
      super();
      this.onThumbActivate = this.onThumbActivate.bind(this);
    }

    connectedCallback() {
      super.connectedCallback();
      this.addEventListener("thumbnail:activate", this.onThumbActivate);
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.removeEventListener("thumbnail:activate", this.onThumbActivate);
    }

    onThumbActivate(event) {
      if (!this.track || !event.detail) return;
      const { index } = event.detail;
      const items = Array.from(this.track.children);
      const target = items[index];
      if (!target) return;
      const centerOffset = (this.track.clientWidth - target.clientWidth) / 2;
      const desiredLeft = target.offsetLeft - centerOffset;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const clamped = Math.max(0, Math.min(maxScroll, desiredLeft));
      this.track.scrollTo({ left: clamped, behavior: "smooth" });
    }
  }
  customElements.define("thumbnail-slider", ThumbnailSlider);
}
